export const ArrowsIcon = ({
  strokeColor,
  size = 22,
}: {
  strokeColor?: string;
  size?: number;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 14.75L9.75 7.75L2.75 0.749999"
      stroke={strokeColor || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 11.75L4.75 7.75L0.750001 3.75"
      stroke={strokeColor || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CCCELogoFull = () => (
  <svg
    width="192"
    height="37"
    viewBox="0 0 192 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M65.9767 23.2632C65.8765 24.8675 64.573 29.2793 58.8577 29.2793C53.0421 29.2793 51.6383 24.8675 51.6383 21.4584C51.6383 16.4449 53.8442 12.735 59.1585 12.735C61.6652 12.735 65.6759 13.838 65.9767 18.6509H61.7654C61.5649 17.6482 60.9633 16.0439 59.0582 16.1441C56.5515 16.1441 55.8496 18.6509 55.8496 20.7565C55.8496 22.4611 55.9499 25.7699 59.0582 25.7699C61.1638 25.7699 61.7654 23.8648 61.7654 23.0627L65.9767 23.2632ZM83.1227 21.1576C83.1227 15.5425 79.3124 12.9355 75.1012 12.9355C70.8899 12.9355 67.0797 15.4423 67.0797 21.1576C67.0797 26.8729 70.8899 29.3796 75.1012 29.3796C79.4127 29.3796 83.1227 26.7726 83.1227 21.1576ZM78.9114 21.1576C78.9114 23.0627 78.3098 25.9705 75.1012 25.9705C71.8926 25.9705 71.291 23.2632 71.291 21.1576C71.291 19.0519 71.8926 16.3447 75.1012 16.3447C78.2095 16.4449 78.9114 19.2525 78.9114 21.1576ZM99.1656 28.9785H95.0546V19.453C95.0546 18.35 94.9543 16.3447 92.4476 16.3447C90.6428 16.3447 89.239 17.6482 89.239 20.0546V28.9785H85.128V13.3366H89.0385V15.6428H89.1388C89.7404 14.7404 90.8433 12.9355 93.8514 12.9355C96.9597 12.9355 99.2659 14.7404 99.2659 18.1495L99.1656 28.9785ZM118.016 11.6321H106.786V16.0439H117.114V19.7538H106.786V25.2686H118.417V29.0788H102.374V7.92211H117.916L118.016 11.6321ZM135.262 7.92211H131.151V15.4423H131.051C130.349 14.4396 129.146 13.0358 126.439 13.0358C123.03 13.0358 119.921 15.6428 119.921 21.0573C119.921 25.2686 121.826 29.3796 126.439 29.3796C128.143 29.3796 129.948 28.778 131.051 26.9731H131.151V28.8782H135.162L135.262 7.92211ZM124.233 21.2578C124.233 18.7511 125.135 16.4449 127.742 16.4449C130.65 16.4449 131.252 18.9517 131.252 21.4584C131.252 23.7645 130.249 25.8702 127.542 25.8702C124.935 25.9705 124.233 23.0627 124.233 21.2578ZM138.07 28.9785H142.181V13.3366H138.07V28.9785ZM138.07 11.4315H142.181V7.62131H138.07V11.4315ZM154.113 18.0492C153.912 17.0466 153.511 15.9436 151.406 15.9436C149.3 15.9436 148.899 16.7457 148.899 17.4476C148.899 19.9543 158.725 18.1495 158.725 23.8648C158.725 28.4772 154.414 29.2793 151.907 29.2793C148.397 29.2793 144.487 27.9758 144.387 23.8648H148.598C148.598 25.2686 149.4 26.171 152.007 26.171C154.113 26.171 154.614 25.1683 154.614 24.5667C154.614 21.9597 144.888 23.8648 144.888 18.0492C144.888 15.7431 146.292 12.8353 151.205 12.8353C154.313 12.8353 157.823 13.6374 158.224 17.949H154.213M175.871 21.1576C175.871 15.5425 172.061 12.9355 167.85 12.9355C163.638 12.9355 159.828 15.4423 159.828 21.1576C159.828 26.8729 163.638 29.3796 167.85 29.3796C172.061 29.3796 175.871 26.7726 175.871 21.1576ZM171.459 21.1576C171.459 23.0627 170.858 25.9705 167.649 25.9705C164.44 25.9705 163.839 23.2632 163.839 21.1576C163.839 19.0519 164.44 16.3447 167.649 16.3447C170.958 16.4449 171.459 19.2525 171.459 21.1576ZM191.814 28.9785H187.703V19.453C187.703 18.35 187.603 16.3447 185.096 16.3447C183.291 16.3447 181.887 17.6482 181.887 20.0546V28.9785H177.776V13.3366H181.687V15.6428H181.787C182.389 14.7404 183.492 12.9355 186.5 12.9355C189.608 12.9355 191.914 14.7404 191.914 18.1495L191.814 28.9785ZM44.0179 32.1871H18.5497C11.0295 32.1871 4.81289 25.9705 4.81289 18.4503C4.81289 10.9302 11.0295 4.71352 18.5497 4.71352H44.1182V0.000896634H18.5497C8.22202 -0.0993719 0 8.22292 0 18.4503C0 28.6777 8.22202 37 18.5497 37H44.1182V32.1871M8.22202 18.4503C8.22202 24.2659 13.0349 29.0788 18.8505 29.0788H44.0179V24.2659H18.8505C15.6419 24.2659 13.0349 21.6589 13.0349 18.4503C13.0349 15.2417 15.6419 12.6347 18.8505 12.6347H44.0179V7.82185H18.8505C13.0349 7.92211 8.22202 12.6347 8.22202 18.4503ZM44.0179 16.0439H18.65C17.2462 16.0439 16.2435 17.0466 16.2435 18.4503C16.2435 19.8541 17.2462 20.8568 18.65 20.8568H43.9176L44.0179 16.0439Z"
      fill="#1a4548"
    />
  </svg>
);

export const CCCELogoSmall = () => (
  <svg
    width="45"
    height="37"
    viewBox="0 0 45 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44.0179 32.1871H18.5497C11.0295 32.1871 4.81289 25.9705 4.81289 18.4503C4.81289 10.9302 11.0295 4.71352 18.5497 4.71352H44.1182V0.000896634H18.5497C8.22202 -0.0993719 0 8.22292 0 18.4503C0 28.6777 8.22202 37 18.5497 37H44.1182V32.1871M8.22202 18.4503C8.22202 24.2659 13.0349 29.0788 18.8505 29.0788H44.0179V24.2659H18.8505C15.6419 24.2659 13.0349 21.6589 13.0349 18.4503C13.0349 15.2417 15.6419 12.6347 18.8505 12.6347H44.0179V7.82185H18.8505C13.0349 7.92211 8.22202 12.6347 8.22202 18.4503ZM44.0179 16.0439H18.65C17.2462 16.0439 16.2435 17.0466 16.2435 18.4503C16.2435 19.8541 17.2462 20.8568 18.65 20.8568H43.9176L44.0179 16.0439Z"
      fill="#1a4548"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00015 15.7331H14.0002M9.01785 1.49715L2.23554 6.77228C1.78217 7.1249 1.55549 7.30121 1.39218 7.52201C1.24752 7.7176 1.13975 7.93794 1.07418 8.17221C1.00015 8.43667 1.00015 8.72385 1.00015 9.29821V16.5331C1.00015 17.6532 1.00015 18.2133 1.21814 18.6411C1.40989 19.0174 1.71585 19.3234 2.09217 19.5152C2.52 19.7331 3.08005 19.7331 4.20015 19.7331H15.8002C16.9203 19.7331 17.4803 19.7331 17.9081 19.5152C18.2845 19.3234 18.5904 19.0174 18.7822 18.6411C19.0002 18.2133 19.0002 17.6532 19.0002 16.5331V9.29821C19.0002 8.72385 19.0002 8.43667 18.9261 8.17221C18.8606 7.93794 18.7528 7.7176 18.6081 7.52201C18.4448 7.30121 18.2181 7.1249 17.7648 6.77228L10.9825 1.49715C10.6311 1.2239 10.4555 1.08727 10.2615 1.03476C10.0903 0.988415 9.90996 0.988415 9.73881 1.03476C9.54484 1.08727 9.36917 1.2239 9.01785 1.49715Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChatIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00003 14L5.92477 17.1137C5.49582 17.548 5.28134 17.7652 5.09698 17.7805C4.93704 17.7938 4.78045 17.7295 4.67599 17.6076C4.55559 17.4672 4.55559 17.162 4.55559 16.5515V14.9916C4.55559 14.444 4.1071 14.0477 3.56523 13.9683C2.25377 13.7762 1.22381 12.7463 1.03171 11.4348C1.00003 11.2186 1.00003 10.9605 1.00003 10.4444V5.8C1.00003 4.11984 1.00003 3.27976 1.32701 2.63803C1.61463 2.07354 2.07357 1.6146 2.63806 1.32698C3.27979 1 4.11987 1 5.80003 1H13.2C14.8802 1 15.7203 1 16.362 1.32698C16.9265 1.6146 17.3854 2.07354 17.673 2.63803C18 3.27976 18 4.11984 18 5.8V10M18 21L15.8236 19.4869C15.5177 19.2742 15.3647 19.1678 15.1982 19.0924C15.0505 19.0255 14.8951 18.9768 14.7356 18.9474C14.5559 18.9143 14.3696 18.9143 13.997 18.9143H12.2C11.0799 18.9143 10.5199 18.9143 10.092 18.6963C9.71573 18.5046 9.40976 18.1986 9.21802 17.8223C9.00003 17.3944 9.00003 16.8344 9.00003 15.7143V13.2C9.00003 12.0799 9.00003 11.5198 9.21802 11.092C9.40976 10.7157 9.71573 10.4097 10.092 10.218C10.5199 10 11.0799 10 12.2 10H17.8C18.9201 10 19.4802 10 19.908 10.218C20.2843 10.4097 20.5903 10.7157 20.782 11.092C21 11.5198 21 12.0799 21 13.2V15.9143C21 16.8462 21 17.3121 20.8478 17.6797C20.6448 18.1697 20.2555 18.5591 19.7654 18.762C19.3979 18.9143 18.9319 18.9143 18 18.9143V21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookIcon = () => (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 17H4.2C3.07989 17 2.51984 17 2.09202 16.782C1.71569 16.5903 1.40973 16.2843 1.21799 15.908C1 15.4802 1 14.9201 1 13.8V4.2C1 3.07989 1 2.51984 1.21799 2.09202C1.40973 1.71569 1.71569 1.40973 2.09202 1.21799C2.51984 1 3.07989 1 4.2 1H4.6C6.84021 1 7.96031 1 8.81596 1.43597C9.56861 1.81947 10.1805 2.43139 10.564 3.18404C11 4.03968 11 5.15979 11 7.4M11 17V7.4M11 17H17.8C18.9201 17 19.4802 17 19.908 16.782C20.2843 16.5903 20.5903 16.2843 20.782 15.908C21 15.4802 21 14.9201 21 13.8V4.2C21 3.07989 21 2.51984 20.782 2.09202C20.5903 1.71569 20.2843 1.40973 19.908 1.21799C19.4802 1 18.9201 1 17.8 1H17.4C15.1598 1 14.0397 1 13.184 1.43597C12.4314 1.81947 11.8195 2.43139 11.436 3.18404C11 4.03968 11 5.15979 11 7.4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LayersIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.00021 10.941L10.6424 15.7621C10.7736 15.8277 10.8392 15.8605 10.908 15.8734C10.9689 15.8848 11.0315 15.8848 11.0924 15.8734C11.1612 15.8605 11.2268 15.8277 11.358 15.7621L21.0002 10.941M1.00021 15.941L10.6424 20.7621C10.7736 20.8277 10.8392 20.8605 10.908 20.8734C10.9689 20.8848 11.0315 20.8848 11.0924 20.8734C11.1612 20.8605 11.2268 20.8277 11.358 20.7621L21.0002 15.941M1.00021 5.94098L10.6424 1.11987C10.7736 1.05428 10.8392 1.02148 10.908 1.00857C10.9689 0.997142 11.0315 0.997142 11.0924 1.00857C11.1612 1.02148 11.2268 1.05428 11.358 1.11987L21.0002 5.94098L11.358 10.7621C11.2268 10.8277 11.1612 10.8605 11.0924 10.8734C11.0315 10.8848 10.9689 10.8848 10.908 10.8734C10.8392 10.8605 10.7736 10.8277 10.6424 10.7621L1.00021 5.94098Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AdvisorsIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 19V17C21 15.1362 19.7252 13.5701 18 13.126M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5C17 6.67869 15.9659 8.11585 14.5 8.70924M16 19C16 17.1362 16 16.2044 15.6955 15.4693C15.2895 14.4892 14.5108 13.7105 13.5307 13.3045C12.7956 13 11.8638 13 10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ConfigurationIcon = () => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 3L2 3M20 3L13 3M13 3.25195C16.4505 4.14004 19 7.27224 19 10.9999M3 10.9999C3 7.27224 5.54955 4.14004 9 3.25195M2.6 15H3.4C3.96005 15 4.24008 15 4.45399 14.891C4.64215 14.7951 4.79513 14.6422 4.89101 14.454C5 14.2401 5 13.9601 5 13.4V12.6C5 12.0399 5 11.7599 4.89101 11.546C4.79513 11.3578 4.64215 11.2049 4.45399 11.109C4.24008 11 3.96005 11 3.4 11H2.6C2.03995 11 1.75992 11 1.54601 11.109C1.35785 11.2049 1.20487 11.3578 1.10899 11.546C1 11.7599 1 12.0399 1 12.6V13.4C1 13.9601 1 14.2401 1.10899 14.454C1.20487 14.6422 1.35785 14.7951 1.54601 14.891C1.75992 15 2.03995 15 2.6 15ZM10.6 5H11.4C11.9601 5 12.2401 5 12.454 4.89101C12.6422 4.79513 12.7951 4.64215 12.891 4.45399C13 4.24008 13 3.96005 13 3.4V2.6C13 2.03995 13 1.75992 12.891 1.54601C12.7951 1.35785 12.6422 1.20487 12.454 1.10899C12.2401 1 11.9601 1 11.4 1H10.6C10.0399 1 9.75992 1 9.54601 1.10899C9.35785 1.20487 9.20487 1.35785 9.10899 1.54601C9 1.75992 9 2.03995 9 2.6V3.4C9 3.96005 9 4.24008 9.10899 4.45399C9.20487 4.64215 9.35785 4.79513 9.54601 4.89101C9.75992 5 10.0399 5 10.6 5ZM18.6 15H19.4C19.9601 15 20.2401 15 20.454 14.891C20.6422 14.7951 20.7951 14.6422 20.891 14.454C21 14.2401 21 13.9601 21 13.4V12.6C21 12.0399 21 11.7599 20.891 11.546C20.7951 11.3578 20.6422 11.2049 20.454 11.109C20.2401 11 19.9601 11 19.4 11H18.6C18.0399 11 17.7599 11 17.546 11.109C17.3578 11.2049 17.2049 11.3578 17.109 11.546C17 11.7599 17 12.0399 17 12.6V13.4C17 13.9601 17 14.2401 17.109 14.454C17.2049 14.6422 17.3578 14.7951 17.546 14.891C17.7599 15 18.0399 15 18.6 15ZM21 3C21 3.55228 20.5523 4 20 4C19.4477 4 19 3.55228 19 3C19 2.44772 19.4477 2 20 2C20.5523 2 21 2.44772 21 3ZM3 3C3 3.55228 2.55228 4 2 4C1.44772 4 1 3.55228 1 3C1 2.44772 1.44772 2 2 2C2.55228 2 3 2.44772 3 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PieChartIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2 12.9821C16.477 12.9821 16.6155 12.9821 16.7278 13.0436C16.8204 13.0943 16.9065 13.1896 16.9478 13.2868C16.9978 13.4047 16.9852 13.53 16.96 13.7808C16.8296 15.0809 16.3822 16.3335 15.6518 17.4267C14.7727 18.7423 13.5233 19.7676 12.0615 20.3731C10.5997 20.9786 8.99113 21.1371 7.43928 20.8284C5.88743 20.5197 4.46197 19.7578 3.34315 18.639C2.22433 17.5201 1.4624 16.0947 1.15372 14.5428C0.84504 12.991 1.00347 11.3824 1.60897 9.92064C2.21447 8.45883 3.23985 7.2094 4.55544 6.33035C5.64856 5.59995 6.90125 5.15251 8.20131 5.02207C8.45207 4.99691 8.57745 4.98433 8.69528 5.03432C8.79249 5.07556 8.88776 5.16175 8.9385 5.25435C9 5.36661 9 5.50511 9 5.7821V12.1821C9 12.4621 9 12.6021 9.0545 12.7091C9.10244 12.8032 9.17893 12.8797 9.27301 12.9276C9.37996 12.9821 9.51998 12.9821 9.8 12.9821H16.2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 1.7821C13 1.5051 13 1.3666 13.0615 1.25434C13.1122 1.16174 13.2075 1.07555 13.3047 1.03431C13.4225 0.984318 13.5479 0.996895 13.7987 1.02205C15.6271 1.20545 17.346 2.01441 18.6569 3.32525C19.9677 4.63609 20.7767 6.355 20.9601 8.1834C20.9852 8.43417 20.9978 8.55956 20.9478 8.67739C20.9066 8.77459 20.8204 8.86986 20.7278 8.9206C20.6155 8.9821 20.477 8.9821 20.2 8.9821L13.8 8.9821C13.52 8.9821 13.38 8.9821 13.273 8.92761C13.1789 8.87967 13.1024 8.80318 13.0545 8.7091C13 8.60214 13 8.46213 13 8.1821V1.7821Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = () => (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6666 4.16683V3.50016C11.6666 2.56674 11.6666 2.10003 11.485 1.74351C11.3252 1.42991 11.0702 1.17494 10.7566 1.01515C10.4001 0.833496 9.9334 0.833496 8.99998 0.833496H7.66665C6.73323 0.833496 6.26652 0.833496 5.91 1.01515C5.59639 1.17494 5.34142 1.42991 5.18164 1.74351C4.99998 2.10003 4.99998 2.56674 4.99998 3.50016V4.16683M6.66665 8.75016V12.9168M9.99998 8.75016V12.9168M0.833313 4.16683H15.8333M14.1666 4.16683V13.5002C14.1666 14.9003 14.1666 15.6004 13.8942 16.1351C13.6545 16.6055 13.272 16.988 12.8016 17.2277C12.2668 17.5002 11.5668 17.5002 10.1666 17.5002H6.49998C5.09985 17.5002 4.39978 17.5002 3.865 17.2277C3.3946 16.988 3.01215 16.6055 2.77246 16.1351C2.49998 15.6004 2.49998 14.9003 2.49998 13.5002V4.16683"
      stroke="#636363"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8334 15.8335L12.9168 12.9168M15 7.91683C15 11.8288 11.8287 15.0002 7.91671 15.0002C4.00469 15.0002 0.833374 11.8288 0.833374 7.91683C0.833374 4.00481 4.00469 0.833496 7.91671 0.833496C11.8287 0.833496 15 4.00481 15 7.91683Z"
      stroke="#667085"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33337 2.60126H4.83337C3.43324 2.60126 2.73318 2.60126 2.1984 2.87375C1.72799 3.11343 1.34554 3.49588 1.10586 3.96629C0.833374 4.50107 0.833374 5.20113 0.833374 6.60126V13.6013C0.833374 15.0014 0.833374 15.7015 1.10586 16.2362C1.34554 16.7066 1.72799 17.0891 2.1984 17.3288C2.73318 17.6013 3.43324 17.6013 4.83337 17.6013H11.8334C13.2335 17.6013 13.9336 17.6013 14.4683 17.3288C14.9388 17.0891 15.3212 16.7066 15.5609 16.2362C15.8334 15.7015 15.8334 15.0014 15.8334 13.6013V10.1013M5.83335 12.6013H7.2288C7.63646 12.6013 7.84028 12.6013 8.03209 12.5552C8.20215 12.5144 8.36473 12.447 8.51385 12.3557C8.68204 12.2526 8.82617 12.1085 9.11442 11.8202L17.0834 3.85126C17.7737 3.16091 17.7737 2.04162 17.0834 1.35126C16.393 0.660908 15.2737 0.660907 14.5834 1.35126L6.6144 9.32022C6.32615 9.60847 6.18202 9.75259 6.07895 9.92079C5.98757 10.0699 5.92023 10.2325 5.8794 10.4025C5.83335 10.5944 5.83335 10.7982 5.83335 11.2058V12.6013Z"
      stroke="#636363"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AiIcon = () => (
  <svg
    width="156"
    height="156"
    viewBox="0 0 156 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.2292 150.833V114.375M23.2292 41.4583V5M5 23.2292H41.4583M5 132.604H41.4583M85.2083 12.2917L72.5633 45.1688C70.507 50.5153 69.4788 53.1885 67.8799 55.4371C66.4628 57.43 64.7216 59.1712 62.7287 60.5882C60.4802 62.1871 57.8069 63.2153 52.4604 65.2716L19.5833 77.9167L52.4605 90.5617C57.8069 92.618 60.4802 93.6462 62.7288 95.2451C64.7217 96.6622 66.4628 98.4033 67.8799 100.396C69.4788 102.645 70.507 105.318 72.5633 110.665L85.2083 143.542L97.8534 110.665C99.9097 105.318 100.938 102.645 102.537 100.396C103.954 98.4033 105.695 96.6622 107.688 95.2451C109.937 93.6462 112.61 92.618 117.956 90.5617L150.833 77.9167L117.956 65.2716C112.61 63.2153 109.937 62.1871 107.688 60.5882C105.695 59.1712 103.954 57.43 102.537 55.4371C100.938 53.1885 99.9097 50.5153 97.8534 45.1688L85.2083 12.2917Z"
      stroke="#FBFDFF"
      strokeWidth="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
